import { useQuery } from "react-query";
import axios from "axios";

export const usePendingDirectDataImports = ({ enabled = true } = {}) => {
  return useQuery(
    ["pendingDirectDataImports"],
    async () => {
      const { data } = await axios.get("/api/content/listPendingDirectDataImport");
      return data.previews || [];
    },
    {
      enabled,
      staleTime: 5 * 60 * 1000,
    }
  );
};
